<template>
  <div ref="wrap" class="scrollbar">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
  import { nextTick, shallowRef } from 'vue';
  import { useScrollTo } from '@mts-fe/hooks';

  defineOptions({ name: 'ScrollContainer' });

  const wrap = shallowRef();

  /**
   * Scroll to the specified position
   */
  function scrollTo(to: number, duration = 500) {
    nextTick(() => {
      if (!wrap.value) {
        return;
      }
      const { start } = useScrollTo({
        el: wrap.value,
        to,
        duration,
      });
      start();
    });
  }

  /**
   * Scroll to the bottom
   */
  function scrollBottom() {
    nextTick(() => {
      if (!wrap.value) {
        return;
      }
      const scrollHeight = wrap.value.scrollHeight as number;
      const { start } = useScrollTo({
        el: wrap.value,
        to: scrollHeight,
      });
      start();
    });
  }

  defineExpose({
    scrollTo,
    scrollBottom,
  });
</script>

<style lang="less">
  .scrollbar {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: auto;
  }
</style>
